import { InputSwitch } from "primereact/inputswitch";
import React, { useState } from "react";
import { updateMapWarehouseWithStore } from "../../../services/warehouse/WarehouseWithStore";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import SuccessModal from "../../SuccessModal";
import { Checkbox } from "primereact/checkbox";
import { getWarehouseProcessStage, postWarehouseProcessStageSwap } from "../../../services/WarehouseStage/WarehouseStage";
import { useEffect } from "react";
import { createWarehouseStageUsers } from "../../../services/WarehouseStage/WarehouseStageUsers";

const WarehouseStageUserAddModal = ({
  warehouseStageUserAddModalVisible,
  setWarehouseStageUserAddModalVisible,
  sendDataToWarehouseConfig,
  userList,
  warehouseId,
}) => {
  const OrderStatus = userList;

  const ordersData = OrderStatus.filter(
    item => item.user.role === 'ROLE_WAREHOUSE_USER',
  );

  const [warehouseStageData, setWarehouseStageData] = useState([]);

  const fetchUserData = () => {
    getWarehouseProcessStage(warehouseId)
      .then(response => {
        if (!response.data.error) {
          const Res = response.data;
          setWarehouseStageData(Res);
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const [selectedWarehouseStage, setSelectedWarehouseStage] = useState([]);
  const [selectedWarehouseUserStage, setSelectedWarehouseUserStage] = useState(
    [],
  );
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState('');

  const handleWarehouseStageToggle = status => {
    const updatedStatus = [status];
    setSelectedWarehouseStage(updatedStatus);
  };

  const handleWarehouseUserStageToggle = status => {
    const updatedStatus = [status];
    setSelectedWarehouseUserStage(updatedStatus);
  };

  const handleDataSubmit = () => {
    const updatedData = {
      stageId: selectedWarehouseStage[0].id,
      wareHouseUserId: selectedWarehouseUserStage[0].id,
    };
    createWarehouseStageUsers(warehouseId, updatedData)
      .then(response => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res) {
            const message = Res.message;
            const status = Res.status;
            setWarehouseStageUserAddModalVisible(false);
            sendDataToWarehouseConfig({
              success: true,
            });
            if (status === true) {
              setModalVisible(true);
              setModalStatus('success');
              setModalText(message);
            } else {
              setModalVisible(true);
              setModalStatus('not Success');
              setModalText(message);
            }
            setSelectedWarehouseStage([]);
            setSelectedWarehouseUserStage([]);
          }
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };


  const handleModalClose = () => {
    setWarehouseStageUserAddModalVisible(false);
    setSelectedWarehouseStage([]);
    setSelectedWarehouseUserStage([]);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={warehouseStageUserAddModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!warehouseStageUserAddModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-1 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
             <div></div>

              <p className=" text-4xl text-primary-50 font-semibold">
                ADD USER
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>
            <div
              className="h-20rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
              <div className="mx-4">
                <p className="text-xl">Warehouse Process Stage</p>
                 
                 
                {warehouseStageData?.length > 0 ? (
                  warehouseStageData?.map(item => (
                    <div key={item.priority}>
                      <div
                        className=" flex my-1 mx-1 p-2 border-round-md shadow-4"
                        key={item.id}
                        style={{
                          borderRadius: 5,
                          backgroundImage:
                            "radial-gradient(circle at left top, #FEBE10, #FFFF00)",
                          flex: 1,
                        }}
                      >
                        <p className="flex-1 text-lg">{item.stage.substring(0, 24)}
                        {item.stage.length > 24 ? '...' : ''}</p>
                        <Checkbox
                          checked={selectedWarehouseStage.includes(item)}
                          color={
                            selectedWarehouseStage.includes(item) ? "#00A3FF" : "#000"
                          }
                          onClick={() => handleWarehouseStageToggle(item)}
                          size={25}
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <div>
                    <p className="text-xl font-medium">No User Data Found</p>
                  </div>
                )}
              </div>

              <div className="mx-4">
                <p className="text-xl">Warehouse Stage User</p>
                 
                 
                {ordersData?.length > 0 ? (
                  ordersData?.map(item => (
                    <div key={item.id}>
                      <div
                        className=" flex my-1 mx-1 p-2 border-round-md shadow-4"
                        key={item.id}
                        style={{
                          borderRadius: 5,
                          backgroundImage:
                            "radial-gradient(circle at left top, #1CD8D2, #93EDC7)",
                          flex: 1,
                        }}
                      >
                        <p className="flex-1 text-lg">
                        {(
                              item.user.firstName +
                              ' ' +
                              item.user.lastName
                            ).substring(0, 24)}
                            {(item.user.firstName + ' ' + item.user.lastName)
                              .length > 24
                              ? '...'
                              : ''}</p>
                        <Checkbox
                          checked={selectedWarehouseUserStage.includes(item)}
                          color={
                            selectedWarehouseUserStage.includes(item) ? "#00A3FF" : "#000"
                          }
                          onClick={() => handleWarehouseUserStageToggle(item)}
                          size={25}
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <div>
                    <p className="text-xl font-medium">No User Found</p>
                  </div>
                )}
              </div>
            </div>

            {OrderStatus?.length !== 0 && (
              <div className="flex ">
                <Button
                  onClick={handleDataSubmit}
                  className="mb-3 mx-4 border-round-xl w-full"
                  disabled={selectedWarehouseStage?.length <= 0 ||
                    selectedWarehouseUserStage?.length <= 0}
                >
                  <p className=" w-full text-2xl font-semibold flex justify-content-center">
                    ADD
                  </p>
                </Button>
              </div>
            )}
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
};

export default WarehouseStageUserAddModal;
